import React, {Component} from 'react'
import {Row, Col} from 'antd';
import {I_LOGISTICS_STATUS, I_ORDER_STATUS} from '../../utills/constants'

export default class ImportTrackShortInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {order, entName} = this.props;
        return (
            <div className="order-info-details">
                <Row className='order-info-item'>
                    <Col span={8}>
                        <span className='label'>订单编号：</span>
                        <span>{order.orderNo}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>揽收单位：</span>
                        <span>{entName}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>提交时间：</span>
                        <span>{order.commitDt}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>订单状态：</span>
                        <span>{I_ORDER_STATUS[order.orderStatus]}</span>
                    </Col>
                    <Col span={8}>
                        <span className='label'>物流状态：</span>
                        <span>{I_LOGISTICS_STATUS[order.logisticsStatus]}</span>
                    </Col>
                </Row>
            </div>
        )
    }
}